<p-toast />
<hr class="mt-0" />
<form [formGroup]="form" (submit)="onSave()" class="w-full">
  <div class="flex flex-column gap-2 mb-4">
    <label emRequiredMark for="status">{{ 'layout.configurations.status.labels.statusEn'| translate }}</label>
    <input
      id="status"
      formControlName="status"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.status.placeholders.statusEn' | translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('status').invalid }" />
    <div *ngIf="isInvalid('status').invalid" class="text-red-600">{{ isInvalid('status').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('status') | translate }}</div>
      <label emRequiredMark for="statusEs">{{ 'layout.configurations.status.labels.statusEs'| translate }}</label>
    <input
      id="statusEs"
      formControlName="statusEs"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.status.placeholders.statusEs' | translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('statusEs').invalid }" />
    <div *ngIf="isInvalid('statusEs').invalid" class="text-red-600">{{ isInvalid('statusEs').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('statusEs') | translate }}</div>
      <label emRequiredMark for="statusAr">{{ 'layout.configurations.status.labels.statusAr'| translate }}</label>
    <input
      id="statusAr"
      formControlName="statusAr"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.status.placeholders.statusAr' | translate"
      class="w-full"
      dir="rtl"
      [ngClass]="{ 'p-invalid': isInvalid('statusAr').invalid }" />
    <div *ngIf="isInvalid('statusAr').invalid" class="text-red-600">{{ isInvalid('statusAr').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('statusAr') | translate }}</div>
  </div>
  <hr />
  <div class="flex justify-content-end mb-4">
    <p-button type="submit" icon="pi pi-check" [label]="'layout.configurations.status.addStatus.save' | translate"></p-button>
  </div>
</form>
